export default __webpack_public_path__ + "static/media/iPhone-X.2a125535.png";